import React from "react";
import StatusBadge, {
  StatusBadgeColorVariant,
} from "@/shared/components/StatusBadge";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { TransportationStatus } from "@/features/transportations/transportation.type";

interface Props {
  status?: TransportationStatus;
}

type CondensedTransportationStatus = "IN_TRANSIT" | "DELIVERED";

const transportationStatusColorVariantMap: Record<
  CondensedTransportationStatus,
  StatusBadgeColorVariant
> = {
  IN_TRANSIT: "blue",
  DELIVERED: "green",
};

function TransportationStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();
  const condensedStatus =
    status === "DOMESTIC_SHIPPING_COMPLETED" ? "DELIVERED" : "IN_TRANSIT";

  if (!status) return null;

  return (
    <StatusBadge
      status={tTitle(
        "transportation.condensed_status." + condensedStatus.toLowerCase()
      )}
      colorVariant={transportationStatusColorVariantMap[condensedStatus]}
      size={"medium"}
    />
  );
}

export default TransportationStatusBadge;
